import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Layout/Header';
import Home from './pages/Home';
import GameDetail from './pages/GameDetail';
import Admin from './pages/Admin';
import Login from './pages/Login';
import CategoryGames from './pages/CategoryGames';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const GA_TRACKING_ID = "G-WDB1BX3DCG";

function usePageTracking() {
  const location = useLocation();

  React.useEffect(() => {
    if ((window as any).gtag) {
      (window as any).gtag("config", GA_TRACKING_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}
function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const isGameDetail = location.pathname.startsWith('/game/');
  const isHomePage = location.pathname === '/';

  const [featuredGames, setFeaturedGames] = React.useState<any[]>([]);
  // React.useEffect(() => {
  //   fetch('/api/games/featured')
  //     .then(res => res.json())
  //     .then(data => setFeaturedGames(data));
  // }, []);

  usePageTracking();

  React.useEffect(() => {
    if (isHomePage) {
      document.title = 'RandPlays - Play Random Free Games Online';
    }
  }, [location, isHomePage]);

  const handleRandomGame = async (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e) e.currentTarget.blur();
    try {
      const res = await fetch('/api/games/random');
      if (!res.ok) throw new Error('No random game');
      const randomGame = await res.json();
      if (randomGame.urlkey) {
        navigate(`/game/${randomGame.urlkey}`);
        return;
      }
    } catch (e) {
      // fallback
      navigate(`/`);
    }
  };

  return (
    <div className="App">
      <Header />
      {/*{(isHomePage || isGameDetail) && (
        <div className="random-button-container">
          <button onClick={e => handleRandomGame(e)}>
            <img src="/images/touzi.png" alt="Random" />
            <span>Random Game</span>
          </button>
        </div>
      )}*/}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/game/:urlkey" element={<GameDetail />} />
        <Route path="/login" element={<Login />} />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          } 
        />
        <Route path="/category/:categoryId" element={<CategoryGames />} />
      </Routes>
      <div className="footer">
        <a href="/privacy.html">Privacy</a> | <a href="/tos.html">TOS</a> | <a href="/contact.html">Contact</a> | <span style={{ marginLeft: '10px' }}>@RandPlays</span>
      </div>
    </div>
  );
}

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
};

export default App;
